module.exports = __webpack_public_path__ + "static/media/hosting_action_bg.5d5545e8.png";